import { Alerts } from "../../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../../contexts/RPCContext.js";
import { EventTypeTitle } from "../../EventTypeTitle.js";
import { EventDetails } from "../EventDetails/index.js";
import { useMemo } from "react";
import { ButtonWithActionModal } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { pluralize } from "@therms/web-js";
//#region src/modules/Events/shared/EventInteractive/components/ChangeEventStateButtonActionModal.tsx
function ChangeEventStateButtonActionModal({ event, eventType, refresh, ...props }) {
	const { rpcService } = useRPCContext();
	const handleClose = async () => {
		try {
			await rpcService.Events.CloseEvent.v1.call({ eventId: event.id });
			Alerts.success("Event closed");
			refresh();
		} catch (err) {
			console.log("Events.CloseEvent.v1.call() err", err);
			Alerts.error("There was a problem closing the event", err.message);
		}
	};
	const closeBody = useMemo(() => {
		const dispositionCounts = Object.values(event.dispositionFormInputByAssignedUserId || {}).length;
		const incompleteDispositions = event.assignedUsers.length - dispositionCounts;
		if (eventType.formsConfig.dispositionFormId && incompleteDispositions) return /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EventDetails, {
				event,
				eventType,
				refresh
			}) }),
			/* @__PURE__ */ jsx("hr", { className: "border-neutral opacity-40" }),
			/* @__PURE__ */ jsxs("div", {
				className: "mt-3",
				children: [
					/* @__PURE__ */ jsxs("span", {
						className: "font-bold",
						children: [
							incompleteDispositions,
							" incomplete",
							" ",
							pluralize("disposition", incompleteDispositions)
						]
					}),
					" ",
					"by assigned Users. Are you sure you want to close this Event?"
				]
			})
		] });
		return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(EventDetails, {
			event,
			eventType,
			refresh
		}) }), /* @__PURE__ */ jsx("div", {
			className: "mt-3",
			children: "Close this Event?"
		})] });
	}, [event]);
	if (event.state !== "closed") return /* @__PURE__ */ jsx(ButtonWithActionModal, {
		...props,
		body: closeBody,
		variant: "main",
		actionText: "Close Event",
		title: /* @__PURE__ */ jsxs("span", { children: ["Close Event ", /* @__PURE__ */ jsx(EventTypeTitle, { eventType })] }),
		onAction: handleClose
	});
	return null;
}
//#endregion
export { ChangeEventStateButtonActionModal };

//# sourceMappingURL=ChangeEventStateButtonActionModal.js.map